import React from 'react';
import {imageCdnUrls} from "../../components/common/ImageCdnUrls";
import PropTypes from "prop-types";
import {sortDirection} from "../assignments/assignmentsPage/assignmentsList/AssignmentsConstants";

export const SortArrow = ({direction, className}) => {
    const [iconSrc, alt] = direction === sortDirection.descending
        ? [imageCdnUrls.caretDownGrey, 'down']
        : [imageCdnUrls.caretUpGrey, 'up'];

    return <img src={iconSrc} className={`assignments-sort-svg ${className}`} alt={alt} />;
};

SortArrow.propTypes = {
    direction: PropTypes.oneOf([sortDirection.ascending, sortDirection.descending]),
    className: PropTypes.string
};
